/** Фото серии для слайдера «Договора» и подборка в чат — ровно то, что отдаёт
 *  `GET /api/serials/{serial}/photos`. Спека `docs/specs/2026-10-22-contract-photos-design.md`. */
import { apiFetch } from "@/lib/api";

export type SerialPhotoGroup = "model" | "hanger";
export type SerialPhotoAngle = "front" | "back" | "side" | "decor" | null;

export type SerialPhoto = { id: number; url: string; group: SerialPhotoGroup; angle: SerialPhotoAngle; main: boolean };

export type SerialPhotos = {
  serial: number;
  model_id: number;
  photos: SerialPhoto[];
  /** Подборка в чат: на модели — спереди, сзади, сбоку; на модели нет — одно главное фото. */
  send: number[];
  send_group: "model" | "main" | null;
  /** Разметка «на модели» не удалась (сайдкар, CRM) — фото без метки стоят «на вешалке». */
  warning: string | null;
};

export const GROUP_LABEL: Record<SerialPhotoGroup, string> = { model: "На модели", hanger: "На вешалке" };
export const ANGLE_LABEL: Record<Exclude<SerialPhotoAngle, null>, string> = {
  front: "спереди",
  back: "сзади",
  side: "сбоку",
  decor: "детали",
};

export const serialPhotosQuery = (serial: number) => ({
  queryKey: ["serial-photos", serial],
  queryFn: () => apiFetch<SerialPhotos>(`/api/serials/${serial}/photos`),
  // Разметка первого открытия — секунды на сайдкаре; дальше фото модели меняются редко.
  staleTime: 10 * 60_000,
});

/** Фото — файлом для поля ответа «Чатов». Имя видит клиент: серия, без артикула. */
export async function serialPhotoFile(serial: number, photo: SerialPhoto, n: number): Promise<File> {
  const r = await fetch(photo.url, { credentials: "include" });
  if (!r.ok) throw new Error(`Фото ${photo.id} серии ${serial} не загрузилось`);
  const blob = await r.blob();
  const ext = blob.type === "image/webp" ? "webp" : blob.type === "image/png" ? "png" : "jpg";
  return new File([blob], `${serial}-${n}.${ext}`, { type: blob.type || "image/jpeg" });
}

/** Подпись к фото в чат — «название · серия N», как товар везде в кабинете. */
export const serialCaption = (name: string, serial: number) => `${name} · серия ${serial}`;
